import "@tento-ui/component-builtin";

import { LonaWebComponent, html } from "@tento-ui/component";
import { Row } from "@tento-ui/component-builtin";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";

/**
 * Onboarding tip card: the core keyboard shortcuts.
 *
 * Informational only — no callbacks. The `◯` checkmark on the host card is the
 * only "complete" affordance. Keep this list in sync with the keys registered
 * in `lib/core/app/hotkeys.ts` (the source of truth for the live bindings).
 */
const SHORTCUTS: ReadonlyArray<{ keys: readonly string[]; label: string }> = [
  { keys: ["⌘", "K"], label: "Open spotlight" },
  { keys: ["D", "W", "M"], label: "Day / Week / Month" },
  { keys: ["T"], label: "Jump to today" },
  { keys: ["E"], label: "New event" },
  { keys: ["←", "→"], label: "Previous / Next" },
  { keys: ["⌘", "\\"], label: "Toggle sidebar" },
];

@component({ name: "std-nux-hotkeys-card" })
export class NuxHotkeysCard extends LonaWebComponent {
  private $rows: HTMLElement = this.$("rows");

  static makeWith(): NuxHotkeysCard {
    return NuxHotkeysCard.make().bind();
  }

  bind(): this {
    this.$rows.replaceChildren();
    for (const shortcut of SHORTCUTS) {
      const $row = Row.make();
      $row.classList.add("row");

      const $keys = Row.make();
      $keys.classList.add("keys");
      for (const key of shortcut.keys) {
        const $key = document.createElement("span");
        $key.classList.add("keycap");
        $key.textContent = key;
        $keys.appendChild($key);
      }
      $row.appendChild($keys);

      const $label = document.createElement("span");
      $label.classList.add("label");
      $label.textContent = shortcut.label;
      $row.appendChild($label);

      this.$rows.appendChild($row);
    }
    return this;
  }

  static $styles = [
    css`
      :host {
        display: block;
        height: 100%;
      }

      #container {
        height: 100%;
        padding: 16px;
        justify-content: center;
      }

      #rows {
        gap: 10px;
      }

      .row {
        align-items: center;
        gap: 10px;
      }

      .keys {
        gap: 4px;
        flex-shrink: 0;
      }

      .keycap {
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        background: var(--bg-surface-light);
        box-shadow: var(--box-shadow-very-light);
        color: var(--text-sec);
        font-size: var(--text-11px);
        font-weight: 500;
      }

      .label {
        color: var(--text-sec);
        font-size: var(--text-12px);
      }
    `,
  ];

  static $html = html`
    <std-col id="container">
      <std-col id="rows"></std-col>
    </std-col>
  `;
}
